import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const employerContractAPI = createApi({
    reducerPath: 'employerContractAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getUnAssignedContracts: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/CompanyContract/GetAllUnAssignedEmployerContracts?companyID=${details}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAssignedContracts: builder.mutation({
            query: (details) => ({
                url: '/CompanyContract/GetAssignedEmployerContracts',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        assignContractsToCompany: builder.mutation({
            query: (details) => ({
                url: '/CompanyContract/AssignEmployerContract',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteAssignedContract: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CompanyContract/DeleteAssignedEmployerContract?companyContractID=${details}`),
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        contractInputFile: builder.mutation({
            query: (details) => ({
                url: '/CompanyContract/ContractInputFile',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateAssignEmployerContract: builder.mutation({
            query: (details) => ({
                url: '/CompanyContract/UpdateAssignEmployerContract',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        downloadContractFile: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/CompanyContract/DownloadFile?folderName=${details.folderName}&fileName=${details.fileName}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateProjectContract: builder.mutation({
            query: (details) => ({
                url: '/CompanyContract/UpdateProjectContract',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useLazyGetUnAssignedContractsQuery,
    useGetAssignedContractsMutation,
    useAssignContractsToCompanyMutation,
    useDeleteAssignedContractMutation,
    useContractInputFileMutation,
    useUpdateAssignEmployerContractMutation,
    useLazyDownloadContractFileQuery,
    useUpdateProjectContractMutation,

} = employerContractAPI

export default employerContractAPI